var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8EarProtection50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11,21c-1.654,0-3,1.346-3,3v4c0,1.654,1.346,3,3,3h4V21H11z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37,21h-4v10h4c1.654,0,3-1.346,3-3v-4C40,22.346,38.654,21,37,21z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24,8c-6.617,0-12,5.383-12,12v2h3v-2c0-4.963,4.038-9,9-9s9,4.037,9,9v2h3v-2 C36,13.383,30.617,8,24,8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.025,30c-2.05,5.825-6.616,8-9.025,8s-6.976-2.175-9.025-8H13.18v0.926 C15.384,36.885,20.253,40,24,40c3.746,0,8.616-3.115,10.82-9.074V30H33.025z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8EarProtection50);
export default __webpack_public_path__ + "static/media/icons8-ear-protection-50.cc66bcd2fd21a53136ba1e62856b3a44.svg";
export { ForwardRef as ReactComponent };